// extracted by mini-css-extract-plugin
module.exports = {"placeholder":"LoadingPlaceholder_placeholder__3HBIp","shimmer":"LoadingPlaceholder_shimmer__3IArd","Shimmer":"LoadingPlaceholder_Shimmer__cTox5"};